const ScoreCircle = ({score = 28, total = 30, passingScore = 25}) => {
    return (
        <div className="flex items-center justify-center mt-2 w-full">
            <div
                className={`
    rounded-full p-2
    ${score === total
                    ? 'bg-green-200'
                    : score >= passingScore && score < total
                        ? 'bg-orange-200'
                        : 'bg-red-200'
                }
  `}
            >
                <div
                    className={`rounded-full ${score === total
                        ? 'bg-green-600'
                        : score >= passingScore && score < total
                            ? 'bg-orange-600'
                            : 'bg-red-600'
                    } w-48 h-48 flex flex-col items-center justify-center text-white`}>
                    <p className="text-lg font-medium">Your Score</p>
                    <p className="text-3xl font-bold">{score}/{total}</p>
                </div>
            </div>
        </div>
    );
};

export default ScoreCircle;
